import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { GoalService } from "@gtmhub/goals/goal.service";
import { IGoal } from "@gtmhub/goals/models";
import { INgRedux } from "@gtmhub/state-management";
import { IQService, IPromise } from "angular";
import { IModalScope } from "angular-ui-bootstrap";
import { IPlanningSession } from "../models/models";
import { PlanningSessionsActions } from "@gtmhub/sessions";
import { ISessionsStoreState } from "@gtmhub/sessions";
import { PlanningSessionService } from "@gtmhub/sessions";

const bindStateToScope = (state: ISessionsStoreState) => {
  const demoSession = state.sessions.items.find((s) => s.demo);
  return {
    demoSession: demoSession,
  };
};

export interface IDemoSessionScope extends IModalScope {
  demoSession: IPlanningSession;
  planningSessionName: string;
  indicators: {
    deleting: boolean;
  };
  deleteDemoSession(): void;
}
export class DemoSessionCtrl {
  public static $inject = ["$scope", "$q", "GoalService", "PlanningSessionService", "UIErrorHandlingService", "$ngRedux", "PlanningSessionsActions"];

  constructor(
    private $scope: IDemoSessionScope,
    private $q: IQService,
    private goalService: GoalService,
    private planningSessionService: PlanningSessionService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $ngRedux: INgRedux,
    private planningSessionsActions: PlanningSessionsActions
  ) {
    this.$scope.indicators = {
      deleting: false,
    };

    this.$scope.deleteDemoSession = this.deleteDemoSession;

    const unsubscribe = this.$ngRedux.connect(bindStateToScope)(this.$scope);
    this.$ngRedux.dispatch(this.planningSessionsActions.getSessionsIfMissing());

    this.$scope.$on("$destroy", unsubscribe);
  }

  private deleteDemoSession = (): void => {
    this.$scope.indicators.deleting = true;

    this.$q
      .all({
        goals: this.goalService.getGoalsWithParams({
          sessionId: this.$scope.demoSession.id,
        }),
      })
      .then(
        (resolvedPromiseMap) => {
          const promises = this.generatePromiseMapWithItemsToDelete(resolvedPromiseMap.goals);

          this.$q.all(promises).then(
            () => {
              // this should be separate from deleting goal because if this resolves before goal deletion
              // it will return error that you only can delete goals in open session and will send these goals to
              // objectives without session
              this.planningSessionService.deletePlanningSession(this.$scope.demoSession.id).then(
                () => {
                  this.$scope.indicators.deleting = false;
                  this.$scope.$close();
                },
                (error) => this.uiErrorHandlingService.handleModal(error)
              );
            },
            (error) => this.uiErrorHandlingService.handleModal(error)
          );
        },
        (error) => this.uiErrorHandlingService.handleModal(error)
      );
  };

  private generatePromiseMapWithItemsToDelete = (goals: IGoal[]): { [id: string]: IPromise<void> } => {
    const itemsToDeletePromiseMap = {};

    goals.forEach((goal: IGoal) => {
      itemsToDeletePromiseMap[goal.id] = this.goalService.deleteGoal(goal.id);
    });

    return itemsToDeletePromiseMap;
  };
}
